import { Context } from "Context";
import { Fragment, useContext } from "react";
import Column from "components/footer/Column";
import AccessibleText from "components/shared/AccessibleText";
import Separator from "components/shared/Separator";

const Columns = ({
	columns = [],
	accessibleText,
	isMobileView = false,
	footer = {},
}) => {
	const {
		config: { brand, locale },
	} = useContext(Context);
	return (
		<Fragment>
			<AccessibleText>{accessibleText}</AccessibleText>
			<div
				className={`syndicated-footer__list syndicated-footer__list--${brand}--${locale}`}
			>
				{columns.map((section, index) => (
					<section
						key={index}
						className={`syndicated-footer__list__column syndicated-footer__list__column--${section.id}`}
					>
						{section.modules?.map((content, index) => (
							<Column
								{...content}
								key={index}
								isMobileView={isMobileView}
								innerHtml
							/>
						))}
					</section>
				))}
			</div>
			{Object.keys(footer).length > 0 && (
				<Separator section="footer" hideInMobile />
			)}
		</Fragment>
	);
};

export default Columns;
